import { useTheme } from 'styled-components';
import { T as ThemeModePreference, a as ThemeMode } from './ThemeMode-DBlsP3Iq.js';
import { s as setThemeMode } from './setThemeMode-cd7Qb3dS.js';

/**
 * Hook that returns the current theme mode from the theme context and a function to update it.
 * @returns Object containing themeMode, themeModePreference, and setThemeMode function.
 */
var useThemeMode = () => {
  var _ref;
  const {
    themeMode,
    themeModePreference
  } = (_ref = useTheme()) !== null && _ref !== void 0 ? _ref : {
    themeMode: ThemeMode.LIGHT,
    themeModePreference: ThemeModePreference.LIGHT
  };
  return {
    themeMode,
    themeModePreference,
    setThemeMode
  };
};

export { useThemeMode as u };
//# sourceMappingURL=useThemeMode-u5aJEVzi.js.map
